module.exports = __webpack_public_path__ + "images/logo_white_brand.svg";